import React, { Component } from 'react'

// Externals
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { Typography, withStyles } from '@material-ui/core'

import { Paper } from 'components'

// Component styles
import styles from './style'

class OrderStatus extends Component {
  render () {
    const { classes, className, status = {}, ...rest } = this.props

    const rootClassName = classNames(classes.root, className)

    return (
      <Paper
        {...rest}
        className={rootClassName}
      >
        <div className={classes.content}>
          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant='body2'
            >
              Orders Today
            </Typography>
            <Typography
              className={classes.value}
              variant='body2'
            >{status.orders.today}
            </Typography>
          </div>
          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant='body2'
            >
              Active Orders
            </Typography>
            <Typography
              className={classes.value}
              variant='body2'
            >{status.orders.all_completed}
            </Typography>
          </div>

          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant='body2'
            >
              Not Confirmed Order
            </Typography>
            <Typography
              className={classes.value}
              variant='body2'
            >{status.orders.all_completed}
            </Typography>
          </div>
          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant='body2'
            >
              Completed Orders
            </Typography>
            <Typography
              className={classes.value}
              variant='body2'
            >{status.orders.all_completed}
            </Typography>
          </div>
          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant='body2'
            >
              Cancelled Orders
            </Typography>
            <Typography
              className={classes.value}
              variant='body2'
            >{status.orders.all_completed}
            </Typography>
          </div>
          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant='body2'
            >
              Total Products
            </Typography>
            <Typography
              className={classes.value}
              variant='body2'
            >{status.items.total}
            </Typography>
          </div>
          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant='body2'
            >
              In Stock Products
            </Typography>
            <Typography
              className={classes.value}
              variant='body2'
            >{status.items.in_stock}
            </Typography>
          </div>
        </div>
      </Paper>
    )
  }
}

OrderStatus.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(OrderStatus)
